import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EntityManagerProvider } from './data/entity-manager-provider';
import { SessionInformationService } from './session-information.service';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}

@Injectable()
export class PrepareGuard implements CanActivate {
    constructor(public entityManagerProvider: EntityManagerProvider, private router: Router,
        private sessionInfo: SessionInformationService,
        // private uow: ArkUnitOfWork,
        // private auth: AuthService
        ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            // return true;
            return this.entityManagerProvider
                .prepare()
                .then( () => {
                    // const loggedIn = this.sessionInfo.getItem('logged-in');
                    // if (!loggedIn && !!this.auth.currentUser) {
                    //     this.uow.logs.createEntity({
                    //         message: 'User logged in',
                    //         userName: this.auth.currentUser?.userName,
                    //         level: 'User',
                    //         logged: new Date()
                    //     });
                    //     await this.uow.commit();
                    //     this.sessionInfo.setItem('logged-in', true);
                    // }
                    return true})
                .catch(error => {
                    // if (e.status == 401) {
                    //     //this.authService.redirectUrl = state.url;
                    //     this.router.navigate(['/login']);
                    //     return false;
                    // }

                    console.error('Error connecting to data service: ' + EntityManagerProvider.serviceName, error);
                    return false;
                });
        } catch (error) {
            return false;
        }
    }
}
